import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import { useNotification } from "../../context/NotificationContext";
import { NotificationType } from "../../enums/NotificationType";

import axios from "../../api/axios";
import config from '../../config/configJS';

const Uploader = ({ id }) => {

    const { showNotification } = useNotification();

    const [t, ] = useTranslation('global');
    const [files, setFiles] = useState([]);
    const [progress, setProgress] = useState({started: false, pc: 0 }); 

    const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({
        //accept: "application/pdf, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint,text/plain, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document ",
        onDrop: (acceptedFiles) => {
            setFiles(acceptedFiles);
          }
      });

    useEffect(()=> {
        setProgress(0);
    },[id]);

    useEffect(() => {
        if (acceptedFiles.length > 0) {
            setFiles(acceptedFiles);
        }
    }, [acceptedFiles]);

    function handleUpload() {
        if (!files.length > 0) {
            showNotification({ message: t('noFileSelected'), type: NotificationType.Error });
            return;
        }

        const formData = new FormData();
        files.forEach((file) => {
            formData.append("files", file);
        });

        showNotification({ message: t('uploading'), type: NotificationType.Info });

        setProgress(prevState => {
            return {...prevState, started: true}
        })

        axios.post(config.endPoint + '/api/millai/SaveFile', formData, {
            onUploadProgress: (progressEvent) => { 
                setProgress(prevState => {
                    return {... prevState, pc: progressEvent.progress * 100 }
                });
            },
            headers: {
                "json": JSON.stringify({ "docsEnvId": id }),  
            },
            withCredentials: true
        })
        .then(res => {
            showNotification({ message: t('uploadSuccess'), type: NotificationType.Info });
            console.log(res.data);

            const timeoutId = setTimeout(() => {
                setFiles([]);
                setProgress({ started: false, pc: 0 }); 
            }, 1000);

            return () => clearTimeout(timeoutId);
        })
        .catch(err => {
            showNotification({ message: t('uploadError'), type: NotificationType.Info });
            console.error(err);
        });
    }

    return (
        <div className="uploader">
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              {isDragActive ?
                  <p className="upload-drop">
                    <span className="material-symbols-outlined drag-drop">
                        download
                    </span>
                    {t('dropFilesHere')}
                  </p> :
                  <p className="upload-msg">
                    <span className="material-symbols-outlined drag-drop">
                        upload_file
                    </span>
                    {t('dragNDrop')}
                  </p>
                }
            </div>
            <ul>
            {files.map((file) => (
                <li key={file.name}>{file.name} {file.type} {file.size} </li>
            ))}
            </ul>
            <button className="submit-button" onClick={() => handleUpload()}>{t('upload')}</button>  
            { progress.started && <progress className="upload-progress" max="100" value={progress.pc}></progress> }
        </div>
    );
}

export default Uploader;
